

import Users from '@/entities/Users/UserMap';
import Leagues from '@/entities/Leagues/LeaguesMap';
import Markets from '@/entities/Markets/MarketsMap';
import TextConstant from '@/entities/TextConstant/TextConstantMap';
import Teams from '@/entities/Teams/TeamsMap';
import Coupons from '@/entities/Coupons/CouponsMap';
import CouponsExpired from '@/entities/Coupons/CouponsExpiredMap';
import Games from '@/entities/Games/GamesMap';
import Missions from '@/entities/Missions/MissionsMap';
import Transactions from '@/entities/Transactions/TransactionsMap';
import Countries from '@/entities/Countries/CountriesMap';
import Points from '@/entities/Points/PointsMap';
import Catalogue from '@/core/config/viewMapping/Catalogue/CatalogueMap';
import Purchases from '@/entities/Purchases/PurchasesMap';
import Faq from '@/entities/Faq/FaqMap';
import BettingCompanies from '@/entities/BettingCompanies/BettingCompaniesMap';
import ContactFormRequests from '@/entities/ContactFormRequests/ContactFormRequestsMap';
import ReportIssue from '@/entities/ReportIssue/ReportIssueMap';
import Tournaments from '@/entities/Tournaments/TournamentsMap';
import TournamentPoints from '@/entities/TournamentPoints/TournamentPointsMap';
import Sponsors from '@/entities/Sponsors/SponsorsMap';


import { Endpoints } from '@/api/ApiEndpoints';

import { Names } from '@/core/config/enums/SitePaths'; 

const GeneralListMapping = [
	
	{
		key: Names.LEAGUES,
		map: Leagues,
		endpoint: Endpoints.LEAGUES,
		deleteEndpoint: Endpoints.DELETE_LEAGUES,
	},
	{
		key: Names.MARKETS,
		map: Markets,
		endpoint: Endpoints.MARKETS,
		deleteEndpoint: Endpoints.MARKETS,
		
	},
	{
		key: Names.TEXT_CONSTANTS,
		map: TextConstant,
		endpoint: Endpoints.TEXT_CONSTANTS,
		deleteEndpoint: Endpoints.TEXT_CONSTANTS,
		
	},
	{
		key: Names.TEAMS,
		map: Teams,
		endpoint: Endpoints.TEAMS,
		deleteEndpoint: Endpoints.DELETE_TEAMS,
	},
	{
		key: Names.COUPONS,
		map: Coupons,
		endpoint: Endpoints.COUPONS,		
	},
	{
		key: Names.COUPONS_EXPIRED,
		map: CouponsExpired,
		endpoint: Endpoints.COUPONS_EXPIRED,
	},
	{
		key: Names.GAMES,
		map: Games,
		endpoint: Endpoints.GAMES,
	},
	{
		key: Names.MISSIONS,
		map: Missions,
		endpoint: Endpoints.MISSIONS,
		deleteEndpoint: Endpoints.DELETE_MISSION
	},
	{
		key: Names.TRANSACTIONS,
		map: Transactions,
		endpoint: Endpoints.TRANSACTIONS,
		deleteEndpoint: Endpoints.DELETE_TRANSACTION
	},
	{
		key: Names.POINTS,
		map: Points,
		endpoint: Endpoints.ADMIN_POINTS,
	},
	{
		key: Names.TOURNAMENTS,
		map: Tournaments,
		endpoint: Endpoints.ADMIN_TOURNAMENT,
		deleteEndpoint: Endpoints.ADMIN_TOURNAMENT,
	},
	{
		key: Names.TOURNAMENT_POINTS,
		map: TournamentPoints,
		endpoint: Endpoints.ADMIN_TOURNAMENT_POINTS,
	},
	{
		key: Names.SPONSORS,
		map: Sponsors,
		endpoint: Endpoints.ADMIN_SPONSOR,
	},
	{
		key: Names.PURCHASES,
		map: Purchases,
		endpoint: Endpoints.ADMIN_PURCHASES
	},
	{
		key: Names.COUNTRIES,
		map: Countries,
		endpoint: Endpoints.COUNTRIES,
		deleteEndpoint: Endpoints.DELETE_COUNTRIES,
	},
	{
		key: Names.FAQ,
		map: Faq,
		endpoint: Endpoints.ADMIN_FAQ,
		deleteEndpoint: Endpoints.ADMIN_FAQ,
		updateOrderEndpoint: Endpoints.ADMIN_FAQ_ORDER,
	},
	{
		key: Names.CONTACT_FORM_REQUESTS,
		map: ContactFormRequests,
		endpoint: Endpoints.ADMIN_CONTACT_FORM,
	},
	{
		key: Names.REPORT_ISSUE_REQUESTS,
		map: ReportIssue,
		endpoint: Endpoints.ADMIN_REPORT_AN_ISSUE,
	},
	{
		key: Names.BETTING_COMPANIES,
		map: BettingCompanies,
		endpoint: Endpoints.BETTING_COMPANIES,
		deleteEndpoint: Endpoints.BETTING_COMPANIES,
	},
	{
		key:  Names.LEAGUES_ORDER_PAGE,
		map: Catalogue,
		endpoint: Endpoints.LEAGUES_ALL,
		updateOrderEndpoint: Endpoints.UPDATE_LEAGUES_ORDER
		
	},
	{
		key: Names.USERS,
		map: Users,
		endpoint: Endpoints.USERS,
		deleteEndpoint: Endpoints.DELETE_USERS,
		disableEndpoint: Endpoints.DISABLE_ENDPOINT,
	},
	
	
];
const getMapping = (route) => {
	
	const filteredMaps = GeneralListMapping.filter(function (ele) {
		return ele.key == route;
	});
	if (filteredMaps.length > 0) {
		
		return filteredMaps[0];
	}
	return;
};

export { GeneralListMapping, getMapping };
